// Network configuration for encore-dashboard
// This file registers all API endpoints with the toolkit

import { endpointRegistry } from '@locus-taxy/encore-ui-network';

// Define all endpoints
const endpoints = {
  // Entity Management
  // NOTE: entities.list is deprecated in favor of modules.list
  // Modules (Left navigation configuration)
  'modules.list': {
    path: '/encore/api/v1/view/clients/:clientId/modules',
    method: 'GET' as const,
  },
  'entity.details': {
    path: '/encore/api/v1/view/clients/:clientId/entities/:entityName/instances/:instanceId',
    method: 'GET' as const,
  },
  'entity.search': {
    path: '/encore/api/v1/clients/:clientId/entities/:entityName/search',
    method: 'POST' as const,
  },
  'entity.metadata': {
    path: '/encore/api/v1/view/clients/:clientId/entities/:entityName/metadata',
    method: 'GET' as const,
  },

  // Client Metadata (unauthenticated)
  'client.metadata': {
    path: '/encore/api/v1/view/clients/:clientId/metadata',
    method: 'GET' as const,
    requireAuth: false,
  },

  // Team Management
  'teams.list': {
    path: '/encore/api/v1/clients/:clientId/entities/team/search',
    method: 'POST' as const,
  },

  // Workflow Actions
  'workflow.action': {
    path: '/encore/api/v1/workflow/clients/:clientId/entities/:entityName/instances/:instanceId/action',
    method: 'POST' as const,
  },

  // Workflow Actions
  'workflow.createAction': {
    path: '/encore/api/v1/workflow/clients/:clientId/entities/:entityName',
    method: 'POST' as const,
  },

  // Export/Import
  'export.action': {
    path: '/encore/api/v1/workflow/clients/:clientId/entities/:entityName/export',
    method: 'POST' as const,
  },
  'import.action': {
    path: '/encore/api/v1/workflow/clients/:clientId/entities/:entityName/import',
    method: 'POST' as const,
  },
  'analytics.dashboard.token': {
    path: '/encore/api/v1/view/clients/:clientId/analytics-dashboard/:dashboardId/token',
    method: 'POST' as const,
  },

  // Bulk Workflow Actions
  'bulk.queryActions': {
    path: '/encore/api/v1/view/clients/:clientId/entities/:entityName/query-bulk-actions',
    method: 'POST' as const,
  },
  'bulk.invokeAction': {
    path: '/encore/api/v1/clients/:clientId/workflow/entities/:entityName/bulk-action',
    method: 'POST' as const,
  },

  // me api to get current user
  'me.get': {
    path: '/encore/api/v1/view/clients/:clientId/me',
    method: 'GET' as const,
  },
};

// Function to register endpoints with the toolkit
export function registerEndpoints() {
  endpointRegistry.registerEndpoints(endpoints);
}
